import Icon from '@ant-design/icons';
import { Button, Divider } from 'antd';
import { ButtonProps } from 'antd/lib/button/button';
import styled from 'styled-components';
import { Cell } from 'styled-css-grid';

export const StyledIcon = styled(Icon)`
  height: 1em;
  width: 1em;
`;

export const Header = styled.div`
  font-weight: bold;
  font-size: 20px;
  color: #414141;
  margin-bottom: 15px;
`;

export const GeneralInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
`;

export const StyledButton: React.FC<ButtonProps> = styled(Button)`
  width: 100px;
`;

export const LinkImg = styled.img`
  height: 75px;
  width: 240px;
  margin-top: 5px;
`;

export const StyledDivider = styled(Divider)`
  margin: 5px 0px 15px 0px;
  background: #c2c2c2;
`;

export const ContentContainer = styled.div`
  max-height: 250px;
  overflow: auto;
`;

export const HomepageLink = styled.a`
  color: #231f20;
  &&& :focus {
    color: #316eb0;
  }
`;

export const ColoredCell = styled(Cell)`
  color: #231f20;
`;

export const StyledLicenseCell = styled(ColoredCell)`
  justify-content: flex-end;
  display: flex;
`;
